export const vuexDefaultMapping = {
  state: ["list", "page", "status", "pages", "count", "query", "totais"],
  actions: [
    "fetchList",
    "fetchRemove",
    "prevPage",
    "nextPage",
    "goPage",
    "firstPage",
    "lastPage",
  ],
  getters: ["loading"],
  mutations: ["setQuery", "setPage"],
}

export default {
  methods: {
    search() {
      this.setPage(1)
      this.fetchList()
    },
  },
}
